import type {DateObj} from './types';

import {not} from '../conditionalUtils';
import {isValidDateTimeString} from './isValidDateTimeString';
import {
  DASH,
  dayValidator,
  DEFAULT_DATE_STRING,
  monthValidator,
  yearValidator,
} from './utils';

/**
 * Returns a date string from a DateObj in the format YYYY-MM-DD
 * @param obj DateObj from the backend
 */
export const dateObjToDateString = (
  obj: DateObj | null | string | undefined,
): string => {
  if (typeof obj === 'string') {
    if (not(isValidDateTimeString(obj))) {
      return DEFAULT_DATE_STRING;
    }

    return obj;
  }

  if (!obj || obj._type !== 'date') {
    return DEFAULT_DATE_STRING;
  }

  return [getYear(obj), DASH, getMonth(obj), DASH, getDay(obj)].join('');
};

function formatZeroPrefix(value: number): string {
  return `0${value}`.slice(-2);
}

function getDay(obj: DateObj) {
  const value = valueOrDefault(obj.day, 1, dayValidator);

  return formatZeroPrefix(value);
}

function getMonth(obj: DateObj) {
  const value = valueOrDefault(obj.month, 1, monthValidator);

  return formatZeroPrefix(value);
}

function getYear(obj: DateObj) {
  return valueOrDefault(obj.year, 3000, yearValidator).toString();
}

function valueOrDefault(
  value: any,
  defaultValue: number,
  validator: (value: any) => boolean,
) {
  if (isNaN(value) || value == null || value === '' || not(validator(value))) {
    return defaultValue;
  }

  return value;
}
